<template>
  <div>
    <!-- :meta="meta"
    :headers="_headers"
    :items="list" -->
    <ListingLayout
      :is-loading="isLoading"
      selected-product="cso"
      :product-options="productOptions"
      :filter-names="filterNames"
      show-date
      search-label="search"
      :show-data-table="false"
      @filterOption="onFiltersChange"
    >
      <template #description>
        <revenue-share-overview
          :data="list"
          :is-loading="isLoading"
        />
      </template>
      <!-- add Filters -->
      <!-- <template #addFilters> </template> -->
      <!-- add Filters -->
      <template #moreFilters>
        <div>
          <refresh-button
            :is-loading="isLoading"
            @reload="fetchData"
          />
        </div>
      </template>
      <!-- Action Modals -->
      <!-- <template #actionModals>
        <div></div>
      </template> -->
      <!-- Action Modals -->
    </ListingLayout>
  </div>
</template>

<script>
import { ListingLayoutMixins } from "@/mixins/ListingLayoutMixins";
import { mapGetters } from "vuex";
// import { debounce } from "lodash";
export default {
  components: {
    ListingLayout: () => import("@/layouts/section/ListingLayout.vue"),
    refreshButton: () => import("@/components/base/RefreshButton.vue"),
    RevenueShareOverview: () => import("./RevenueShareOverview.vue"),
  },
  mixins: [ListingLayoutMixins],

  data() {
    return {
      permissions: {
        view: "config-management.view",
        create: "config-management.create",
        edit: "config-management.edit",
        delete: "config-management.delete",
      },
      productOptions: [
        { id: "oem", value: "OEM" },
        { id: "cso", value: "CSO" },
      ],
      filters: {},
      subFilters: {},
      //
      customFilters: {},
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      isLoading: "revenueShare/getLoading",
      list: "revenueShare/getList",
    }),
    _headers() {
      const headers = [
        // {
        //   text: this.$t("id"),
        //   align: "left",
        //   sortable: true,
        //   value: "id",
        // },
        {
          text: this.$t("charge_point_id"),
          align: "left",
          sortable: false,
          value: "charge_point_id",
        },
        {
          text: this.$t("tenant_name"),
          align: "left",
          sortable: false,
          value: "tenant_name",
          showAdmin: true,
        },
        {
          text: this.$t("manufacturer"),
          align: "left",
          sortable: false,
          value: "manufacturer",
        },
        ...(this.authUser.user_nature == "fleet"
          ? [
              {
                text: this.$t("manufacturer"),
                align: "left",
                sortable: false,
                value: "tenant_name",
              },
            ]
          : []),
        {
          text: this.$t("location"),
          align: "left",
          sortable: false,
          value: "location_name",
        },
        // {
        //   text: this.$t("station_type"),
        //   align: "left",
        //   sortable: false,
        //   value: "station_type",
        // },
        {
          text: this.$t("connectors"),
          align: "center",
          sortable: false,
          value: "charger_connectors_count",
        },
        {
          text: this.$t("power_type"),
          align: "center",
          sortable: false,
          value: "type",
        },
        {
          text: this.$t("access_level"),
          align: "left",
          sortable: false,
          value: "is_private",
        },
        {
          text: this.$t("status"),
          align: "left",
          sortable: false,
          value: "charge_station_status",
        },
        {
          text: this.$t("last_heartbeat_received"),
          align: "left",
          sortable: false,
          value: "last_heartbeat_received",
        },
        {
          text: this.$t("actions"),
          align: "left",
          sortable: false,
          value: "actions",
        },
        // ...(this.isView || this.isEdit || this.isDelete
        //   ? [
        //       {
        //         text: this.$t("actions"),
        //         align: "left",
        //         sortable: false,
        //         value: "actions",
        //       },
        //     ]
        //   : []),
      ];

      // computed headers for showing columns to role based
      return headers.filter(
        (header) =>
          header.showAdmin === undefined ||
          (header.showAdmin != undefined &&
            header.showAdmin === this.authUser.isAdmin)
      );
    },

    filterNames() {
      return ["locations", "charge_point"];
    },
  },
  watch: {
    "options.tenant_id": {
      handler: function (val) {
        if (val) {
          const params = { tenant_id: val };
          this.$store.dispatch("csmsChargeStations/LocationsList", params);
        } else {
          this.$store.commit("csmsChargeStations/SET_LOCATION", []);
        }
      },
    },

    options() {
      this.fetchData();
    },
  },
  async mounted() {},
  beforeDestroy() {
    const params = {
      name: "revenue_share",
      filters: { ...this.options, ...this.customFilters },
    };
    this.$store.commit("redirect/SET_FILTERS", params);
  },
  methods: {
    async fetchData() {
      const params = { ...this.options, ...this.customFilters };
      await this.$store.dispatch("revenueShare/list", params).then(() => {
        if (this.options.page > (this.meta?.lastPage || 1)) {
          this.options.page = 1;
        }
      });
    },
  },
};
</script>
